export default __webpack_public_path__ + "static/media/component_RGB.1b5e9fcb.png";